<h2>{{ 'Gestione disegni' | translate }}</h2>
<ui-table
  [rowSelection]="'checkbox'"
  [fields]="fields"
  [pager]="pager$"
  [filters]="filters$ | async"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  [contextMenuActions]="contextMenus"
  [selected]="selectedItems?.length ? selectedItems : []"
  (itemsPageChange)="applyChangePageHandler($event)"
  [reload]="reload$"
  (select)="selectHandler($event)"
  (rowAction)="manageRowActions($event)">
  <div tableActions>
    <app-entity-actions
      className="BeneD"
      [selectedItemsCount]="selectedItems?.length || 0"
      [config]="{ showExport: !!isExportEnable }"
      (export)="exportHandler()"
      (add)="addHandler()"
      (delete)="deleteSelectedHandler()"
      (collectionAdd)="addToCollectionHandler()">
    </app-entity-actions>
  </div>
  <div tableFilters>
    <ui-filters
      [dialogFilters]="MobileFiltersComponent"
      (action)="applyFilterWithDelayHandler($event)">
      <app-card-s-filters
        [filters]="filtersObj$ | async"
        #desktopFilter>
      </app-card-s-filters>
    </ui-filters>
  </div>
</ui-table>
